import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, finalize } from 'rxjs';

import { TranslateCodePipe } from '@widgets/translate-code.pipe';

enum CommentWidgetState {
  InProgress,
  Success,
  Fail,
}

@UntilDestroy()
@Component({
  selector: 'app-common-comment-widget',
  templateUrl: './common-comment-widget.component.html',
  styleUrls: ['./common-comment-widget.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, TranslateCodePipe],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class CommonCommentWidgetComponent<T> implements OnInit {
  header: string;
  state: CommentWidgetState;
  CommentWidgetState = CommentWidgetState;
  errorCode = 'Failure';
  comment = '';
  inProgress = false;
  doneText = 'Thank you!';
  placeholder = 'Comment...';
  sendText = 'Send comment';

  get jwtToken(): string {
    return this.route.snapshot.queryParams.jwt;
  }

  @ViewChild('commentInput', { read: ElementRef, static: false }) commentInput: ElementRef<HTMLElement>;

  constructor(protected cdr: ChangeDetectorRef, private route: ActivatedRoute) {}

  protected abstract getMainInfo(jwtToken: string): Observable<T>;
  protected abstract setPredefineInfo(info: T): void;
  protected abstract sendComment(jwtToken: string, comment: string): Observable<null>;

  isCommentValid() {
    return !!this.comment;
  }

  ngOnInit() {
    this.getMainInfo(this.jwtToken)
      .pipe(finalize(() => this.cdr.detectChanges()))
      .subscribe({
        next: info => {
          this.setPredefineInfo(info);
          this.state = CommentWidgetState.InProgress;
          setTimeout(() => this.commentInput.nativeElement.focus());
        },
        error: err => {
          this.errorCode = err?.error ?? '';
          this.state = CommentWidgetState.Fail;
        },
      });
  }

  scrollToButton() {
    const buttonElement = document.querySelector('.button-panel');
    buttonElement?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

  post() {
    if (this.inProgress || !this.isCommentValid()) {
      return;
    }
    this.inProgress = true;
    this.sendComment(this.jwtToken, this.comment)
      .pipe(finalize(() => (this.inProgress = false)))
      .subscribe({
        next: () => {
          this.state = CommentWidgetState.Success;
          this.cdr.detectChanges;
        },
        error: err => {
          this.errorCode = err?.error ?? '';
          this.state = CommentWidgetState.Fail;
          this.cdr.detectChanges;
        },
      });
  }
}
